import * as React from 'react'
// import * as classnames from 'classnames'

import * as styles from './storydoc.css'

import { bind } from 'bind-decorator'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import SwipeableViews from 'react-swipeable-views'
import { virtualize, SlideRendererParams } from 'react-swipeable-views-utils'
import { StoreComponent, injectStores } from '../../store'
import { RouteComponentProps } from 'react-router-dom'

import { isIE } from '../../utils/Platform'
import { Story } from './story'
import { ProgressBar } from './cover/progressBar'
import { OfflineOverlay } from '../offline/offlineOverlay'
// import { Portal } from 'react-portal'

const SwipeableViewsVirtual = virtualize(SwipeableViews)

// const leftArrow = require('./slide-arrow-left.svg')
// const rightArrow = require('./slide-arrow-right.svg')
// const leftArrowBig = require('./big-arrow-left.svg')
// const rightArrowBig = require('./big-arrow-right.svg')

@injectStores
@observer
export class Storydoc extends StoreComponent<RouteComponentProps<{ slideIdx: string }>> {
  @observable scrollTop = 0
  @observable sliderArrowPadding: string = '20vh'
  @observable arrowBoxTopMargin: string = '0px'
  @observable leftArrowText: string = ''
  @observable rightArrowText: string = ''
  introSlidesCount: number = 0

  timer: number = 0

  constructor (props: any, context: any) {
    super(props, context)
    // this.store.storyDocContent.getChapter(this.props.match.params.slideIdx)
    if (this.store.storyDocContent.chapters.length === 0) {
      this.store.storyDocContent.fetchChapters()
      .then(() => {
        for (const chapter of this.store.storyDocContent.chapters) {
          if (this.props.match.params.slideIdx === chapter.uidAlt) {
            if (this.store.storeCommon.menu.language === 'de') this.store.storeCommon.menu.language = 'en'
            else this.store.storeCommon.menu.language = 'de'
            this.store.storyDocContent.fetchChapters()
            .then(() => this.gotoSlide(this.idToSlideIdx(this.props.match.params.slideIdx)))
          }
        }
        this.gotoSlide(this.idToSlideIdx(this.props.match.params.slideIdx))
      })
    } else {
      this.gotoSlide(this.idToSlideIdx(this.props.match.params.slideIdx))
    }
  }

  componentDidUpdate (prevProps: RouteComponentProps<{ slideIdx: string }>) {
    if (this.props.match.params.slideIdx !== prevProps.match.params.slideIdx) {
      this.gotoSlide(this.idToSlideIdx(this.props.match.params.slideIdx))
    }
    this.scrollTop = this.store.storyDocUI.scrollPositions[this.store.storyDocUI.currentSlideIdx]
  }

  componentDidMount () {
    // window.addEventListener('scroll', this.handleScroll, true)
    window.clearTimeout(this.timer)
  }

  componentWillUnmount () {
    window.clearTimeout(this.timer)
  }

  // @bind
  // handleScroll (e: any) {
  //   this.scrollTop = e.target.scrollTop
  //   if (this.scrollTop < 10) {
  //     this.store.storeCommon.menu.showProgressBar = true
  //   } else {
  //     this.store.storeCommon.menu.showProgressBar = false
  //   }
  // }

  @bind
  handleSwitching () {
    if (!this.store.storeCommon.currentStory.paused) this.store.storeCommon.currentStory.paused = true
  }

  public render () {
    // console.log('storydoc props', this.props)
    return (
      <div className={styles.container} >
        { !this.store.appStore.online && this.store.breakpoints.phone && <OfflineOverlay />}
        <ProgressBar open={ this.store.storeCommon.menu.showProgressBar }/>
        <SwipeableViewsVirtual
          animateTransitions={!isIE}
          slideRenderer={(i) => this.slideRenderer(i)}
          enableMouseEvents index={this.store.storyDocUI.currentSlideIdx}
          onChangeIndex={this.slideChanged}
          onSwitching={this.handleSwitching}
          slideCount={this.store.storyDocContent.chapters.length + this.introSlidesCount}
          loop={false}
          disabled={this.store.storeCommon.currentStory.play}
          overscanSlideAfter={isIE ? 0 : 2}
          overscanSlideBefore={isIE ? 0 : 3}
        />
        {/* {
          this.hasPrevious && this.store.storyDocUI.showArrows &&
          <div className={styles.leftArrow} style={{ paddingTop: this.sliderArrowPadding }} onClick={this.slideBackward} >
            <div className={classnames(styles.arrowBox, 'arrow-box')} style={{ marginTop: this.arrowBoxTopMargin }}>
              <div className={styles.leftArrowImg}><img src={this.store.breakpoints.desktop ? leftArrowBig : leftArrow} /></div>
              {this.store.breakpoints.desktop && <div className={styles.leftArrowText}>{this.leftArrowText}</div>}
            </div>
          </div>
        }
        {
          this.hasNext && this.store.storyDocUI.showArrows &&
          <div className={styles.rightArrow} style={{ paddingTop: this.sliderArrowPadding }} onClick={this.slideForward}>
            <div className={classnames(styles.arrowBox, 'arrow-box')} style={{ marginTop: this.arrowBoxTopMargin }}>
              {this.store.breakpoints.desktop && <div className={styles.rightArrowText}>{this.rightArrowText}</div>}
              <div className={styles.rightArrowImg}><img src={this.store.breakpoints.desktop ? rightArrowBig : rightArrow} /></div>
            </div>
          </div>} */}
      </div >
    )
  }

  slideRenderer (param: SlideRendererParams): JSX.Element {
    if (this.store.storyDocContent.chapters.length) return <Story key={param.index} slideIdx={param.index} data={this.store.storyDocContent.chapters[param.index]} goToSection={this.props.location.hash}/>
    return <div key={Math.random()}></div>
  }

  @bind
  slideChanged (slideIdx: number) {
    this.store.storyDocUI.currentSlideIdx = slideIdx
    this.store.storeCommon.currentStory.id = this.store.storyDocContent.chapters[slideIdx].id
    this.slideIdxUpdated()
    this.store.storeCommon.currentStory.paused = false
  }

  @bind
  slideForward () {
    if (this.hasNext) {
      this.store.storyDocUI.currentSlideIdx += 1
    }
    this.slideIdxUpdated()
  }

  @bind
  slideBackward () {
    if (this.hasPrevious) {
      this.store.storyDocUI.currentSlideIdx -= 1
    }
    this.slideIdxUpdated()
  }

  get hasNext () {
    return this.store.storyDocUI.currentSlideIdx < this.store.storyDocContent.chapters.length + this.introSlidesCount - 1
  }

  get hasPrevious () {
    return this.store.storyDocUI.currentSlideIdx > 0
  }

  @bind
  slideIdxUpdated () {
    const pathname = `/story/${this.slideIdxToId(this.store.storyDocUI.currentSlideIdx)}`
    if (this.store.storeRouter.location.pathname !== pathname) {
      this.store.storeRouter.push(pathname)
      this.store.storeCommon.currentStory.id = null

      setTimeout(() => {
        if (document.body.scrollIntoView) {
          document.body.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' })
        } else {
          window.scrollTo(0, 0)
        }
      }, 500)
    } else return
  }

  gotoSlide (idx: number) {
    if (idx < this.store.storyDocContent.chapters.length + this.introSlidesCount && idx > 0) {
      this.store.storyDocUI.currentSlideIdx = idx
    } else {
      this.store.storyDocUI.currentSlideIdx = 0
    }
  }

  idToSlideIdx (uid?: string): number {
    for (let i = 0; i < this.store.storyDocContent.chapters.length; i++) {
      const chapter = this.store.storyDocContent.chapters[i]
      if (chapter.uid === uid) return i + this.introSlidesCount
    }
    return 0
  }

  slideIdxToId (idx?: number): string {
    if (!idx) return this.store.storyDocContent.chapters[0].uid

    if (idx >= this.introSlidesCount && idx < this.introSlidesCount + this.store.storyDocContent.chapters.length) {
      return this.store.storyDocContent.chapters[idx - this.introSlidesCount].uid
    }

    return this.store.storyDocContent.chapters[0].uid
  }
}



// WEBPACK FOOTER //
// ./src/modules/storydoc/storydoc.tsx